exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-danger{padding:4px 20px;border-radius:4px!important;background-color:#e30606!important}.btn-danger:hover{background:#c70303!important}.btn-success{padding:4px 20px;border-radius:4px!important;background-color:#00a651!important}.btn-success:hover{background:#00a651!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-67376b4c","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/pages/restricted/user/blockDevice/blockDevice.vue
// module id = 634
// module chunks = 0